import { API_URL } from '../../config';
import { logErrorService } from '../services';

export function redirectToHelp(redirectUrl: string) {
  try {
    window.location.href = `${API_URL}/authentication/support?return_to=${encodeURIComponent(redirectUrl)}`;
  } catch (e) {
    logErrorService(e, 'failed redirect');
  }
}
